/* eslint-disable no-console */
import ScratchStorage from 'scratch-storage';
import nets from 'nets';
import defaultProject from './default-project';
import {
    getUserToken
} from './services/query-params';
import {addURLParams} from './query-string';
import {messyParams} from './messy-params';


/**
 * Wrapper for ScratchStorage which adds default web sources.
 * @todo make this more configurable
 */
class Storage extends ScratchStorage {
    constructor () {
        super();
        this.cacheDefaultProject();
        // setTimeout(() => {
        this.webHelper.load = function (assetType, assetId, dataFormat) {
            /** @type {Array.<{url:string, result:*}>} List of URLs attempted & errors encountered. */
            const errors = [];
            const stores = this.stores.slice();
            const asset = new this.parent.Asset(assetType, assetId, dataFormat);
            let storeIndex = 0;

            return new Promise((resolve, reject) => {

                const tryNextSource = () => {

                    /** @type {UrlFunction} */
                    let reqConfigFunction;

                    while (storeIndex < stores.length) {
                        const store = stores[storeIndex];
                        ++storeIndex;
                        if (store.types.indexOf(assetType.name) >= 0) {
                            reqConfigFunction = store.get;
                            break;
                        }
                    }

                    if (reqConfigFunction) {
                        let reqConfig = reqConfigFunction(asset);
                        if (reqConfig === false) {
                            tryNextSource();
                            return;
                        }
                        if (typeof reqConfig === 'string') {
                            reqConfig = {
                                url: reqConfig
                            };
                        }

                        nets(Object.assign({
                            method: 'get'
                        }, reqConfig), (err, resp, body) => {
                            // body is a Buffer
                            if (err || Math.floor(resp.statusCode / 100) !== 2) {
                                let errorJson = {

                                };
                                if (body instanceof Uint8Array) {
                                    try {
                                        errorJson = JSON.parse(new TextDecoder('utf-8').decode(body));
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }
                                if (!err && resp.rawRequest) {
                                    err = {
                                        status: errorJson.status || resp.rawRequest.status,
                                        statusText: errorJson.message || resp.rawRequest.statusText,
                                        asset: asset.decodeText()
                                    };
                                }
                                asset.setData(body, dataFormat);
                                errors.push(err || asset.decodeText());
                                tryNextSource();
                            } else {
                                asset.setData(body, dataFormat);
                                resolve(asset);
                            }
                        });
                    }
                    if (errors.length > 0) {
                        reject(errors);
                    } else if (!reqConfigFunction) {
                        resolve(null); // no stores matching asset
                    }
                };

                tryNextSource();
            });
        };
        // }, 100);
        
    }
    addOfficialScratchWebStores () {
        this.addWebStore(
            [this.AssetType.Project],
            this.getProjectGetConfig.bind(this),
            this.getProjectCreateConfig.bind(this),
            this.getProjectUpdateConfig.bind(this)
        );
        this.addWebStore(
            [this.AssetType.ImageVector, this.AssetType.ImageBitmap, this.AssetType.Sound],
            this.getAssetGetConfig.bind(this),
            // We set both the create and update configs to the same method because
            // storage assumes it should update if there is an assetId, but the
            // asset store uses the assetId as part of the create URI.
            this.getAssetCreateConfig.bind(this),
            this.getAssetUpdateConfig.bind(this)
        );
        this.addWebStore(
            [this.AssetType.Sound],
            asset => `static/extension-assets/scratch3_music/${asset.assetId}.${asset.dataFormat}`
        );
    }
    setProjectHost (projectHost) {
        this.projectHost = projectHost;
    }
    getProjectGetConfig (projectAsset) {
        const {category} = messyParams;
        const path = category === '3' ? 'projects' : 'getScratchExercise';

        // eslint-disable-next-line prefer-const
        let params = {
            id: projectAsset.assetId
        };
        const url = addURLParams(
            `${this.projectHost}/${path}`,
            params
        );
        const urlTemp = addURLParams(
            `${API_BASE_URL}/community/admin/creation/template/scratch/detail`,
            params
        );
        
        return {
            url: category === '3' ? urlTemp : url,
            headers: {
                Authorization: getUserToken() || ''
            }
        };
    }
    // PENGJU S2接口
    getProjectCreateConfig () {
        const {category, fr} = messyParams;

        // 保存模板
        if (category === '3' && fr !== 'tr') {
            return `${API_BASE_URL}/community/admin/creation/template/scratch/save`;
        }

        // 保存作业
        return `${this.projectHost}/saveScratchExercise`;
    }
    
    getProjectUpdateConfig () {
        return {
            method: 'put',
            url: `${this.projectHost}/projects/`
        };
    }
  
    setAssetHost (assetHost) {
        this.assetHost = assetHost;
    }
    getAssetGetConfig (asset) {
        return {
            url: `${this.assetHost}/common/mit/${asset.assetId}.${asset.dataFormat}`
        };
    }
    getAssetCreateConfig (asset) {
        return {
            url: `${this.projectHost}/projects/assets/${asset.assetId}.${asset.dataFormat}/`
        };
    }
    getAssetUpdateConfig (asset) {
        return `${this.projectHost}/projects/assets/${asset.assetId}.${asset.dataFormat}/`;
    }

    //  * 上传分享接口
    //  * @param filePath url
    //  * @param fileName file name
    //  * @param dataFormat 日期, 如20180101
    //  * @returns {{url: string, withCredentials: boolean}} 格式
    getShareUpdateConfig (filePath, fileName, dataFormat) {
        return `${this.assetHost}/${filePath}/${fileName}.${dataFormat}`;
    }
    
    setTranslatorFunction (translator) {
        this.translator = translator;
        this.cacheDefaultProject();
    }
    cacheDefaultProject () {
        const defaultProjectAssets = defaultProject(this.translator);
        defaultProjectAssets.forEach(asset => this.builtinHelper._store(
            this.AssetType[asset.assetType],
            this.DataFormat[asset.dataFormat],
            asset.data,
            asset.id
        ));
    }

}

const storage = new Storage();

export default storage;
